import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { debounce, escape } from 'lodash';

import { changeTextProperty } from './../../../redux/actions/entities/texts';

class TextInput extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      text: null,
    };
    this.changeText = debounce(this.changeText, 500);
  }

  componentDidUpdate(prevProps) {
    const { text } = prevProps;
    const { text: PropsText } = this.props;

    if (text !== PropsText) {
      this.setState({
        text: PropsText,
      });
    }
  }


  setTextWithPre = (text, value) => {
    const preText = text.split(':', 1);
    return `${preText}: ${value.substring(value.indexOf(':') + 1)}`;
  }

  returnTextWithoutPre = text => text.substring(text.indexOf(':') + 2)

  handleChange = (event) => {
    const { isBabyText, text } = this.props;
    const { value } = event.target;
    let replacedText = value.replace(/[[\]{}*+\\^$|#\t]/g, '');
    replacedText = replacedText.replace(/\s{2,}/g, ' ');

    if (isBabyText) {
      replacedText = this.setTextWithPre(text, replacedText);
    }

    this.setState({ text: replacedText });
    this.changeText();
  }

  changeText = () => {
    const { textFieldId } = this.props;
    this.props.dispatch(changeTextProperty(textFieldId, 'text', escape(this.state.text)));
  }

  render() {
    const {
      text,
      lang,
      isBabyText,
    } = this.props;
    let { text: stateText } = this.state;

    let textValue = text;

    if (isBabyText) {
      textValue = this.returnTextWithoutPre(text);
      if (stateText !== null) {
        stateText = this.returnTextWithoutPre(stateText);
      }
    }

    return (
      <div className="col textToolsIcon text-input-wrapper">
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="15.91" height="15.91" viewBox="0 0 15.91 15.91">
          <path d="M13.13.05,11,2.17,1.08,12.09h0L.05,16l3.86-1h0L13.83,5,16,2.87ZM3.91,13.23,2.77,12.09,11.85,3,13,4.15Z" transform="translate(-0.05 -0.05)" />
        </svg>

        <input
          ref={input => input && input.focus()}
          type="text"
          className="bookText"
          value={stateText !== null ? stateText : textValue}
          onChange={this.handleChange}
          placeholder={lang.text_input_placeholder}
        />
      </div>

    );
  }
}

TextInput.defaultProps = {
  text: '',
  textFieldId: 0,
  lang: {},
  dispatch: () => {},
  isBabyText: false,
};

TextInput.propTypes = {
  text: PropTypes.string,
  textFieldId: PropTypes.number,
  lang: PropTypes.object,
  dispatch: PropTypes.func,
  isBabyText: PropTypes.bool,
};

export default connect()(TextInput);



// WEBPACK FOOTER //
// ./src/components/text-tools/text-input/TextInput.jsx